import { reduxForm } from 'redux-form'
import { push } from 'react-router-redux'
import Participants from './create_preferences'
import { NEW_CAMPAIGN_ID, setData } from 'redux/modules/campaign'
import { AMOUNT_TYPES } from 'shared/shared_consts'
import { validateFunc as validateContributionPrefs } from 'components/contribution_prefs'
import { getCampaignSelector } from 'redux/selectors/campaign'

const mapStateToProps = (state, props) => {
  const campaign = getCampaignSelector(state, props)
  return {
    shareProgress: campaign.share_progress,
    validate: validateContributionPrefs(campaign.goal),
    shouldAutoFocus: props.router.params.action !== 'POP',
    initialValues: {
      amountType: campaign.amount_type,
      amountAtLeast: campaign.amount,
      amountExactly: campaign.amount,
      shareContributorsDetails: campaign.share_contributors,
      shareContributionsAmount: campaign.share_contributions,
    },
  }
}

const mapDispatchToProps = dispatch => ({
  onSubmit(formValues) {
    let data = {
      amount_type: formValues.amountType,
      share_contributors: formValues.shareContributorsDetails,
      share_contributions: formValues.shareContributionsAmount,
    }

    if (data.amount_type === AMOUNT_TYPES.at_least) {
      data.amount = formValues.amountAtLeast
    } else if (data.amount_type === AMOUNT_TYPES.exactly) {
      data.amount = formValues.amountExactly
    }

    dispatch(setData(NEW_CAMPAIGN_ID, data))
    dispatch(
      push({ pathname: `${GLOBAL_CONSTS.REQUEST_URI}/c/create/description` })
    )
  },
})

export default reduxForm(
  {
    form: 'create_preferences',
    destroyOnUnmount: false,
    fields: [
      'amountType',
      'amountAtLeast',
      'amountExactly',
      'shareContributorsDetails',
      'shareContributionsAmount',
    ],
    touchOnBlur: false,
    touchOnChange: false,
  },
  mapStateToProps,
  mapDispatchToProps
)(Participants)
